import API from './api';

// Post bildirimlerinde postId zaten geliyor. Yorum bildirimlerinde
// (özellikle "yorumuna oy geldi" bildirimi) backend postId göndermiyor —
// sadece yorumun id'sini gönderiyor. Bu durumda yorumu tek seferlik
// çekip hangi posta bağlı olduğunu buradan öğreniyoruz.
export async function resolveNotificationPostId(notif) {
  const existingPostId = notif.post_id || notif.postId;
  if (existingPostId) return existingPostId;

  const commentId = notif.comment_id || notif.commentId;
  if (!commentId) return null;

  try {
    const res = await API.get(`/comments/${commentId}`);
    return res.data?.post_id || null;
  } catch {
    return null;
  }
}